/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// UpDownButton
const UpDownButton = (props) => {

  // let _onClick = props.onOverrideContent(HeadlinesPicker);
  let _onClick = () => {
    console.log("SampleButton._onClick")
    props.sampleButtonClicked()
  }

  // console.log("props: ", props)

  let _onMouseDown = (event) => event.preventDefault();

  return (
    <div onMouseDown={_onMouseDown} className="headlineButtonWrapper" style={{
      cursor: 'pointer',
    }}>
      <FontAwesomeIcon
        onClick={_onClick}
        icon='arrows-alt-v'
        style={{
          fontSize: 12,
          width: 40,
          marginBottom: 6,
        }} />
    </div>
  )
}
export default UpDownButton
